module.exports = __webpack_public_path__ + "img/symbol_7.3db72ccd.png";